
import { useState } from 'react';
import { Tabs, Tab, Typography, Box } from '@mui/material';


export const AnimatedTab = ({
  tabs,
}: {
  tabs: Array<{ title: string; body: string }>;
}) => {
  const [page, setPage] = useState(0);
  if (!Array.isArray(tabs)) {
    return <> </>;
  }

  // TODO: Need To Handle Animations

  return (
    <Box>
        <Tabs value={page} onChange={(_, v) => setPage(v)} className='pb-2' TabIndicatorProps={{style: {background:'#3DB157'}}}>
          {tabs.map(({ title }) => <Tab label={
            <Typography variant='caption'>{title}</Typography>
          }
          />)}
        </Tabs>
      {tabs.map(({ body }, i) =>
          page === i && <Typography variant='caption' dangerouslySetInnerHTML={{ __html: body }}></Typography>
      )}
    </Box>
  )
};
